import { Component, OnInit } from "@angular/core";
import { CruiseWrapper } from "src/app/classes/cruise-wrapper";
import { CompanyParamsService } from "src/app/services/companyParams/company-params.service";
import { PurchaseRequestService } from "../../services/purchase-request/purchase-request.service";
import { TextInfoTransferEnum } from "../../../enums/text-info-transfer.enum";
import { PaymentMethodTypeEnum } from "../../../enums/payment-methods-type.enum-";

@Component({
  selector: "app-table-payment-summary",
  templateUrl: "./table-payment-summary.component.html",
  styleUrls: ["./table-payment-summary.component.css"],
})
export class TablePaymentSummaryComponent implements OnInit {
  public cruiseLongName: string;
  public bookingTrackCode: string;
  public cruiseWrapper: CruiseWrapper;
  public totalWithoutThirtyPercent: number;
  public totalPrice: number;
  public cruiseItineraryDuration: string;

  constructor(
    public purchaseRequestService: PurchaseRequestService,
    private companyParamsService: CompanyParamsService
  ) {}

  ngOnInit() {
    this.cruiseWrapper = this.purchaseRequestService.getCruiseWrapper();
    this.cruiseLongName = this.getCruiseLongName();
    this.bookingTrackCode = this.getBookingTrackCode();
    this.totalWithoutThirtyPercent = this.getTotalPriceWhitoutDiscoutn();
    this.totalPrice = this.getTotalPrice();
    this.cruiseItineraryDuration = this.cruiseWrapper.getItineraryName();
  }
  private getCruiseLongName(): string {
    try {
      return this.cruiseWrapper.getLongName();
    } catch (error) {
      console.log("BookTourComponent.getCruiseLongName()");
      console.error(error);
      return null;
    }
  }
  private getCruiseItineraryDuration(): string {
    try {
      return this.purchaseRequestService
        .getCruiseWrapper()
        .getCruiseItineraryDuration();
    } catch (error) {
      console.log("BookTourCompoenent.getCruiseItineraryDuration()");
      console.error(error);
      return null;
    }
  }
  private getBookingTrackCode(): string {
    try {
      return this.purchaseRequestService.getBookingTrackCode();
    } catch (error) {
      console.log("BookTourComponent.getBookingTrackCode()");
      console.error(error);
      return null;
    }
  }
  public getTextTotalPaid(): string {
    try {
      let textValue = "";
      if (this.isTransferPayment()) {
        if (this.purchaseRequestService.getIsSelectedThirtyPerent()) {
          textValue = `Initial deposit (${this.companyParamsService.getPercentPartialPayment()}%) to be paid*`;
        } else {
          textValue = TextInfoTransferEnum.TOTAL_TO_BE_PAID;
        }
      } else {
        if (this.purchaseRequestService.getIsSelectedThirtyPerent()) {
          textValue = `Initial deposit (${this.companyParamsService.getPercentPartialPayment()}%) paid*`;
        } else {
          textValue = TextInfoTransferEnum.TOTAL_PAID;
        }
      }
      return textValue;
    } catch (error) {
      console.log("TourSummaryComponent.isPurchaseIncludeAirTickets()");
      console.error(error);
    }
  }
  private getTotalPriceWhitoutDiscoutn(): number {
    try {
      return this.purchaseRequestService.getTotalPriceWithoutDiscount();
    } catch (error) {
      console.log("BookTourComponent.getTotalPrice()");
      console.error(error);
      return 0;
    }
  }
  private getTotalPrice(): number {
    try {
      return this.purchaseRequestService.getTotalPrice();
    } catch (error) {
      console.log("BookTourComponent.getTotalPrice()");
      console.error(error);
      return 0;
    }
  }
  getThanYouText() {
    let textValue = this.isTransferPayment()
      ? TextInfoTransferEnum.TRANSFER_TEXT
      : TextInfoTransferEnum.WITHOUT_TRANSFER_TEXT;

    return textValue;
  }
  getInvoiceText() {
    let textValue = this.isTransferPayment()
      ? TextInfoTransferEnum.TOTAL_INVOICED
      : TextInfoTransferEnum.TOTAL_BILLED;

    return textValue;
  }

  /**
   * Obtiene el nombre del método de pago basado en codePaymenMethod
   * Prioriza el código de pago sobre sessionStorage para evitar conflictos
   */
  getPaymentMethodName(): string {
    const codePaymentMethod = this.purchaseRequestService.purchase.codePaymenMethod;

    // Si hay un código de pago definido, usarlo
    if (codePaymentMethod !== undefined && codePaymentMethod !== null) {
      switch (codePaymentMethod) {
        case PaymentMethodTypeEnum.PAYPAL_CHECKOUT:
          return 'PayPal';
        case PaymentMethodTypeEnum.CREDIT_CARD_ONLINE:
          return 'Credit Card';
        case PaymentMethodTypeEnum.GENERAL_TRANSFER:
          return 'Transfer';
        case PaymentMethodTypeEnum.STRIPE_CHECKOUT:
          return 'Stripe';
        case PaymentMethodTypeEnum.PLACETOPAY:
          return 'Placetopay';
      }
    }

    // Fallback: verificar paymentMethod (solo si no hay codePaymenMethod)
    const paymentMethod = this.purchaseRequestService.getPaymentMethod();
    if (paymentMethod) {
      // Solo retornar Transfer si explícitamente es transfer Y los demás son false
      if (paymentMethod.transfer && !paymentMethod.paypal && !paymentMethod.creditCard) {
        return 'Transfer';
      } else if (paymentMethod.paypal) {
        return 'PayPal';
      } else if (paymentMethod.creditCard) {
        return 'Credit Card';
      } else if (paymentMethod.stripe) {
        return 'Stripe';
      } else if (paymentMethod.placetopay) {
        return 'Placetopay';
      }
    }

    return 'Online Payment';
  }

  /**
   * Verifica si el pago es de tipo transferencia.
   * SOLO retorna true si el código de pago es GENERAL_TRANSFER (3)
   */
  isTransferPayment(): boolean {
    const codePaymentMethod = this.purchaseRequestService.purchase.codePaymenMethod;

    // Si hay código de pago, usar ese
    if (codePaymentMethod !== undefined && codePaymentMethod !== null) {
      return codePaymentMethod === PaymentMethodTypeEnum.GENERAL_TRANSFER;
    }

    // Fallback: verificar si hay PlaceToPay info en session (NO es transfer)
    const placetopayResponse = sessionStorage.getItem('placetopay_payment_response');
    if (placetopayResponse) {
      return false;
    }

    // Solo retornar true si explícitamente es transfer Y los demás son false
    const paymentMethod = this.purchaseRequestService.getPaymentMethod();
    if (paymentMethod) {
      return paymentMethod.transfer && !paymentMethod.paypal && !paymentMethod.creditCard;
    }

    return false;
  }
}
